export default "__VITE_ASSET__d2f3fb74__"